<!--
 * @Author: lishiqiao
 * @Date: 2022-01-10 17:06:58
 * @LastEditors: lishiqiao
 * @LastEditTime: 2023-09-13 14:31:24
-->
<template>
  <div class="page-list">
    <!-- 搜索栏 -->
    <div class="page-search-content" ref="searchBox">
      <div class="page-big-box">
        <div class="page-search-item">
          <label>公司&nbsp;:</label>
          <el-select v-model="params.params.orgId" placeholder="请选择公司">
            <el-option label="全部公司" value=""></el-option>
            <el-option v-for="item in companyList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>批次&nbsp;:</label>
          <el-select v-model="params.params.seedlingDataId" placeholder="请选择批次">
            <el-option label="全部批次" value=""></el-option>
            <el-option v-for="item in batchList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>品类&nbsp;:</label>
          <el-select v-model="params.params.breedTypeId" placeholder="请选择品类">
            <el-option label="全部品类" value=""></el-option>
            <el-option v-for="item in breedTypeList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>品种&nbsp;:</label>
          <el-select v-model="params.params.breedId" placeholder="请选择品种">
            <el-option label="全部品种" value=""></el-option>
            <el-option v-for="item in breedList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <!-- 年月 -->
        <div class="page-search-date">
          <div class="page-search-item">
            <label>月份&nbsp;:</label>
            <el-date-picker v-model="params.params.month" value-format="yyyy-MM" type="month" placeholder="选择月">
              >
            </el-date-picker>
          </div>
        </div>
      </div>
      <div class="page-search-btn">
        <div class="search-btn" @click="search">查询</div>
        <div class="reset-btn" @click="reset">重置</div>
        <div class="search-close-btn">
          <div @click="PageSearchClose" v-if="PageDisplay">
            <span>收起</span><i class="iconfont icon-a-List-Expand"></i>
          </div>
          <div @click="PageSearchOn" v-else>
            <span>展开</span><i class="iconfont icon-List-Collapse"></i>
          </div>
        </div>
      </div>
    </div>
    <!-- 内容 -->
    <div class="page-list-content">
      <!-- 列表 -->
      <div class="page-list-title">
        <div><i class="title-icon"></i>水产养殖排塘损失统计表</div>
        <div>单位 : {{ unitName }}</div>
        <div>月份 :{{ showMonth }}</div>
        <div>
          <el-dropdown style="margin-right: 30px;" @command="setFixedColumn">
            <span class="el-dropdown-link">
              冻结列<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="y">冻结至"{{
                fixedColumn.label
              }}"列</el-dropdown-item>
              <el-dropdown-item command="n">取消冻结</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <span @click="exportTable">
            <i class="title-export-btn iconfont icon-a-List-Export"></i>导出报表
          </span>
        </div>
      </div>
      <!-- 表格 -->
      <el-table :data="tableData" :max-height="tableHeight" border style="width: 100%" :row-class-name="tableRowClassName"
        @header-click="handleClick">
        <el-table-column :fixed="fixedColumnList[0].fixed" :class-name="fixedColumnList[0].selected ? 'cellSelected' : ''"
          prop="orgName" label="单位名称"> </el-table-column>
        <el-table-column :fixed="fixedColumnList[1].fixed" :class-name="fixedColumnList[1].selected ? 'cellSelected' : ''"
          prop="seedlingDataName" label="育苗批次">
        </el-table-column>
        <el-table-column :fixed="fixedColumnList[2].fixed" :class-name="fixedColumnList[2].selected ? 'cellSelected' : ''"
          prop="breedTypeName" label="品类"> </el-table-column>
        <el-table-column :fixed="fixedColumnList[3].fixed" :class-name="fixedColumnList[3].selected ? 'cellSelected' : ''"
          prop="breedName" label="品种"> </el-table-column>
        <el-table-column label="本月排塘情况">
          <el-table-column prop="boxNum" label="塘口数"> </el-table-column>
          <el-table-column prop="lossNum" label="数量"> </el-table-column>
          <el-table-column prop="avgSpec" label="平均规格"> </el-table-column>
          <el-table-column prop="lossWeight" label="重量"> </el-table-column>
          <el-table-column prop="lossCost" label="损失成本"> </el-table-column>
        </el-table-column>
        <el-table-column label="本月累计排塘情况">
          <el-table-column prop="boxNumCy" label="塘口数"> </el-table-column>
          <el-table-column prop="lossNumCy" label="数量"> </el-table-column>
          <el-table-column prop="avgSpecCy" label="平均规格"> </el-table-column>
          <el-table-column prop="lossWeightCy" label="重量"> </el-table-column>
          <el-table-column prop="lossCostCy" label="损失成本">
          </el-table-column>
          <el-table-column prop="lossRateCy" label="排塘率%"> </el-table-column>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import service from "./ym-put-service";
import Page from "@/utils/methods/page";
export default {
  name: "pond",
  data() {
    return {
      PageDisplay: true,
      unitName: "", // 单位名称
      showMonth: "", // 显示的月份
      tableHeight: 0, // 表格高度
      fixedColumn: {},
      fixedColumnList: [
        {
          prop: "orgName",
          fixed: false,
          selected: false
        },
        {
          prop: "seedlingDataName",
          fixed: false,
          selected: false
        },
        {
          prop: "breedTypeName",
          fixed: false,
          selected: false
        },
        {
          prop: "breedName",
          fixed: false,
          selected: false
        },
      ],
      // 分页参数
      params: {
        currPage: 1,
        pageSize: 10,
        orderBy: "desc",
        orderByName: "org_name",
        params: {
          rootOrgId: "",
          orgId: "",
          breedTypeId: "",
          seedlingDataId: "",
          breedId: "",
          type: "M",
          year: "",
          month: this.$moment().format("YYYY-MM"),
          breedTypeClass: "egg",
        },
      },
      exportParams: {}, // 导出参数
      tableData: [],
      companyList: [], // 公司列表
      batchList: [], // 批次列表
      breedTypeList: [], // 品类列表
      breedList: [], // 品种列表
    };
  },
  created() {
    this.tableHeight = window.innerHeight - 400;
    this.params.params.rootOrgId = localStorage.getItem("rootId");
    this.getCompanyList(); // 获取公司列表
    this.getBatchList(); // 获取批次列表
    this.getBreedTypeList(); // 获取品类列表
    this.getBreedList(); // 获取品种列表
    this.getPageList(); // 获取分页
  },
  mounted() {
    Page.pagesTableFixed(); // 表头固定
  },
  methods: {
    /**
     * @Author: lishiqiao
     * @Date: 2022-01-17 17:02:17
     * @description: 获取公司列表
     * @param {*}
     */
    getCompanyList() {
      service
        .getPondCompanyList(this.params.params.rootOrgId)
        .then((res) => {
          if (res.code == "0000") {
            this.companyList = res.data;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-02-25 10:05:50
     * @description: 选择机构/公司
     * @param {*} val
     */
    selectOrg(val) {
      if (!val) {
        return;
      }
      this.params.params.rootOrgId = val;
      this.getBatchList();
      this.getBreedTypeList();
      this.getBreedList();
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-17 17:02:27
     * @description: 获取批次列表
     * @param {*}
     */
    getBatchList() {
      service
        .getPondBatchList(this.params.params.rootOrgId)
        .then((res) => {
          if (res.code == "0000") {
            this.batchList = res.data;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-17 17:02:47
     * @description: 获取品类列表
     * @param {*}
     */
    getBreedTypeList() {
      service
        .getPondBreedTypeList(this.params.params.rootOrgId)
        .then((res) => {
          if (res.code == "0000") {
            this.breedTypeList = res.data;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-17 17:03:01
     * @description: 获取品种列表
     * @param {*}
     */
    getBreedList() {
      service
        .getPondBreedList(this.params.params.rootOrgId)
        .then((res) => {
          if (res.code == "0000") {
            this.breedList = res.data;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    // 查询
    search() {
      this.getPageList();
    },

    // 初始化时间
    initTime() {
      this.params.params.month = null;
      if (this.params.params.type == "M") {
        this.params.params.month = this.$moment().format("YYYY-MM");
      }
    },

    // 重置
    reset() {
      this.params.params.orgId = "";
      this.params.params.seedlingDataId = "";
      this.params.params.breedTypeId = "";
      this.params.params.breedId = "";
      this.params.params.month = this.$moment().format("YYYY-MM");
      this.initTime();
      this.getPageList();
    },

    // 收起
    PageSearchClose() {
      Page.PageSearchClose(this);
    },

    // 展开
    PageSearchOn() {
      Page.PageSearchOn(this);
    },

    // 合计行高亮class赋予
    tableRowClassName({ row, rowIndex }) {
      if (row.orgName === "合计") {
        return "heji-row";
      }
    },

    // 显示的单位-月
    showListData() {
      if (this.params.params.orgId) {
        this.unitName = this.companyList.filter(
          (item) => item.id == this.params.params.orgId
        )[0].name;
      } else {
        this.unitName = "恒兴水产养殖事业部";
      }
      if (this.params.params.type == "M") {
        this.showMonth = this.$moment(this.params.params.month).format(
          "YYYY年MM月"
        );
      }
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-10 14:50:03
     * @description: 获取育苗明细分页
     * @param {*}
     */
    getPageList() {
      const loading = this.$loading({
        lock: true,
        text: "数据加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      service
        .getPondPageList(this.params)
        .then((res) => {
          if (res.code == "0000") {
            this.tableData = res.data.list;
            this.showListData();
            this.exportParams = JSON.parse(JSON.stringify(this.params.params));
          } else {
          }
          loading.close();
        })
        .catch((err) => {
          this.$message.error(err);
          loading.close();
        });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-10 15:49:07
     * @description:导出
     * @param {*}
     */
    exportTable() {
      this.$confirm(`导出表格为excel文件，请确认！`, "操作提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.exportParams.fileName = "育苗投放概览排塘情况";
          service
            .exportPondData(this.exportParams)
            .then((res) => { })
            .catch((err) => {
              this.$message.error(err);
            });
        })
        .catch((err) => {
          // this.$message.error(err);
        });
    },

    // 选中列
    handleClick(column, event) {
      this.fixedColumnList.forEach((item, i) => {
        if (JSON.stringify(this.fixedColumnList).includes(column.property)) {
          if (item.prop === column.property) {
            item.selected = !item.selected;
            if (item.selected) {
              this.fixedColumn = column;
              this.fixedColumn.idx = i;
            } else {
              this.fixedColumn = {};
            }
          } else {
            item.selected = false;
          }
        }
      });
    },

    // 设置冻结列
    setFixedColumn(command) {
      if (command === 'y') {
        if (JSON.stringify(this.fixedColumn) === "{}") {
          this.$message('请选择列');
          return;
        }
        this.fixedColumnList.forEach(item => {
          item.fixed = false;
          item.selected = false;
        })
        this.fixedColumnList.forEach((item, i) => {
          if (i <= this.fixedColumn.idx) {
            item.fixed = true;
          }
        })
        this.$message('已冻结至"' + this.fixedColumn.label + '"列');
        this.fixedColumn = {};
      } else if (command === 'n') {
        this.fixedColumnList.forEach(item => {
          item.fixed = false;
          item.selected = false;
        })
        this.$message('已取消冻结');
      }
    }
  },
};
</script>

<style></style>